import { render, staticRenderFns } from "./SidebarCountryLink.vue?vue&type=template&id=b5b3ccc0&scoped=true"
import script from "./SidebarCountryLink.vue?vue&type=script&lang=ts"
export * from "./SidebarCountryLink.vue?vue&type=script&lang=ts"
import style0 from "./SidebarCountryLink.vue?vue&type=style&index=0&id=b5b3ccc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b3ccc0",
  null
  
)

export default component.exports